import { alpha } from "@mui/material/styles";

export const MuiInputLabel = (mode) => {
  return {
    MuiInputLabel: {
      styleOverrides: {
        root: ({ theme }) => ({
          fontSize: "18px",
          color: theme.palette.text.secondary,
          "&.Mui-focused": {
            color: theme.palette.primary.main,
          },
          "&.Mui-error": {
            color: theme.palette.error.main,
          },
          // 18px is for the shrunk label (scaled to 75% in the notch). Resting
          // inside an empty field the label stands in for a placeholder, so it
          // takes the input's size and the placeholder's colour
          "&:not(.MuiInputLabel-shrink)": {
            fontSize: theme.typography.body1.fontSize,
            color: alpha(theme.palette.text.primary, theme.palette.mode === "light" ? 0.42 : 0.5),
          },
        }),
      },
    },
  };
};
